import classNames from 'classnames';
import { Button } from '@carbon/react';
import { TrashCan } from '@carbon/react/icons';
import style from './trash-button.module.scss';
import { VFC } from 'react';

export interface Props extends Omit<
  React.ComponentProps<typeof Button>,
  'ref'
> {
  adjustForLabel?: boolean;
  description: string;
}

const TrashButton: VFC<Props> = ({
  adjustForLabel = false,
  className,
  description,
  renderIcon = TrashCan,
  ...rest
}) => {
  className = classNames(className, { [style.adjustForLabel]: adjustForLabel });

  return (
    <Button
      hasIconOnly
      renderIcon={renderIcon}
      iconDescription={description}
      tooltipAlignment="end"
      tooltipPosition="top"
      className={className}
      {...rest}
    />
  );
};

export { TrashButton };
